import {
    Component,
    OnInit,
    ViewEncapsulation,
    ViewContainerRef
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Helpers } from '../../../../../../helpers';
import { SweetAlertService } from '../../../../../../_services/sweetalert.service';
import { ValidationService } from '../../../../../../_services/validation.service';
import { BaseComponent } from '../../../base.component';
import { Customer } from '../../../../../../models/customer';
import { CustomerService } from '../../../../../../services/customer.service';
import { AgencyService } from '../../../../../../services/agency.service';
import { Agency } from '../../../../../../models/agency';

@Component({
    selector: 'app-update-agency',
    templateUrl: './update-agency.component.html',
    encapsulation: ViewEncapsulation.None
})
export class UpdateAgencyComponent extends BaseComponent implements OnInit {
    model: Agency = new Agency();

    constructor(
        private agencyService: AgencyService,
        private router: Router,
        route: ActivatedRoute
    ) {
        super();
        this.model.id = route.snapshot.params['id'];
    }

    ngOnInit() {
        this.initPhoneMasks();
        this.initTaxMasks();
        this.getAgency();
    }

    initPhoneMasks() {
        (<any>$('#phone')).inputmask({
            mask: '(999) 999 9999'
        });
    }

    initTaxMasks() {
        (<any>$('#taxNumber')).inputmask({
            mask: '99999999999'
        });
    }

    getAgency() {
        Helpers.setLoading(true);
        this.agencyService.find(this.model.id).subscribe(res => {
            this.model = res.data;

            Helpers.setLoading(false);
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                name: customRules.requiredText
            }
        });
    }

    updateAgency() {
        var _self = this;
        Helpers.setLoading(true);
        this.model.phone = (<any>$('#phone')).val();
        this.model.taxNumber = (<any>$('#taxNumber')).val();
        this.agencyService.update(this.model).subscribe(res => {
            Helpers.setLoading(false);
            this.swalService.successUpdate();
            setTimeout(function() {
                _self.router.navigate(['/publisher/agency/list']);
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/publisher/agency/update-agency/update-agency.component.ts